import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AddressManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class AddressManagerCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getAddressManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressManagerCreateActions.getAddressManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getAddressManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            AddressManagerCreateActions.getAddressManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              AddressManagerCreateActions.getAddressManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
